import styled from "styled-components";

export const StyledErrors = styled.ul`
  background: #fde4e447;
  border-radius: 8px;
  border: 1px solid #c50000;
  color: #c50000;
  padding: 16px 23px 16px 45px;
  margin-bottom: 40px;
`;

export const StyledError = styled.li``;
